export default (params) => ({
  trigger: {
    name: 'content_blocks.image_entrances.select_entrance',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'two_entrances',
          'four_entrances',
          'two_entrances_image',
          'four_entrances_image',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_navigation',
    },
  },
});
